/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".profession-field[_ngcontent-%COMP%]{margin-bottom:-5px}.cursor-pointer[_ngcontent-%COMP%]{cursor:pointer}.mat-focused[_ngcontent-%COMP%]   .placeholder[_ngcontent-%COMP%]{color:transparent}"];
export { styles as styles };
